<div
  [ngClass]="'dropdown-item--' + type"
  class="dropdown-item"
>
  <ng-content></ng-content>
</div>

